export const environment = {
	production: true,
	clockUrl: "https://test-clock.timetjek.nu",
	apiUrl: "https://test-api.timetjek.nu",
	clockAppUrl: "https://test-clock2.timetjek.nu"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts